import * as types from "../action/ActionType";

interface DashboardAction {
  type: string;
  payload: boolean;
}

export default function DashboardReducer(state: boolean = false, action: DashboardAction): boolean {
  const { type, payload } = action;
  switch (type) {
    case types.ISUPDATED:
      return payload;
    default:
      return state;
  }
}
